module.exports = __webpack_public_path__ + "img/trunk_2x3_z18.636abcea.svg";